import React, { useState, useEffect } from "react";
import { LifeBuoy, X, PhoneCall, Mail, MessageSquare } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./SupportBox.module.scss";

const SupportBox = () => {
  const [showPopup, setShowPopup] = useState(false);

  // UX Enhancement: Close popup when user presses ESC key
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setShowPopup(false);
      }
    };

    if (showPopup) {
      document.addEventListener("keydown", handleEsc);
    }
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [showPopup]);

  // UX Enhancement: Prevent closing when clicking inside the popup box
  const handleBoxClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <div className={styles["admin-sup-box__card"]}>
        {/* HEADER */}
        <div className={styles["admin-sup-box__header"]}>
          <div className={styles["admin-sup-box__icon-wrapper"]}>
            <LifeBuoy size={18} strokeWidth={2.5} />
          </div>
          <h3 className={styles["admin-sup-box__title"]}>Need Assistance?</h3>
        </div>

        {/* CONTENT */}
        <div className={styles["admin-sup-box__content"]}>
          <p className={styles["admin-sup-box__text"]}>
            If you need help with this API or have questions, our support team
            is here to help. You can also check out our detailed documentation
            and community forums.
          </p>

          <button
            type="button"
            className={styles["admin-sup-box__btn"]}
            onClick={() => setShowPopup(true)}
          >
            <MessageSquare size={16} strokeWidth={2.5} />
            Contact Support
          </button>
        </div>
      </div>

      {/* POPUP OVERLAY */}
      {showPopup && (
        <div
          className={styles["admin-sup-box__overlay"]}
          onClick={() => setShowPopup(false)} // Clicking outside closes it
        >
          <div
            className={styles["admin-sup-box__popup"]}
            onClick={handleBoxClick}
          >
            <button
              className={styles["admin-sup-box__close-btn"]}
              onClick={() => setShowPopup(false)}
              aria-label="Close"
            >
              <X size={20} strokeWidth={2.5} />
            </button>

            <h3 className={styles["admin-sup-box__popup-title"]}>
              Contact Support
            </h3>

            {/* CONTACT DETAILS LIST */}
            <div className={styles["admin-sup-box__contact-list"]}>
              <div className={styles["admin-sup-box__contact-item"]}>
                <PhoneCall
                  size={24}
                  strokeWidth={2}
                  className={styles["admin-sup-box__contact-icon"]}
                />
                <div className={styles["admin-sup-box__contact-info"]}>
                  <span className={styles["admin-sup-box__contact-label"]}>
                    Mobile
                  </span>
                  <span className={styles["admin-sup-box__contact-value"]}>
                    +91-141-4576564
                  </span>
                </div>
              </div>

              <div className={styles["admin-sup-box__contact-item"]}>
                <Mail
                  size={24}
                  strokeWidth={2}
                  className={styles["admin-sup-box__contact-icon"]}
                />
                <div className={styles["admin-sup-box__contact-info"]}>
                  <span className={styles["admin-sup-box__contact-label"]}>
                    Email
                  </span>
                  <span className={styles["admin-sup-box__contact-value"]}>
                    support@doql.com
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SupportBox;
